"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable:member-access */

var Step_1 = __importDefault(require("@material-ui/core/Step"));

var StepLabel_1 = __importDefault(require("@material-ui/core/StepLabel"));

var Stepper_1 = __importDefault(require("@material-ui/core/Stepper"));

var styles_1 = require("@material-ui/core/styles");

var moment_1 = __importDefault(require("moment"));

var react_1 = __importDefault(require("react"));

require("./BB8Stepper.scss");

var styles = function styles(theme) {
  return styles_1.createStyles({
    backButton: {
      marginRight: theme.spacing.unit
    },
    instructions: {
      marginBottom: theme.spacing.unit,
      marginTop: theme.spacing.unit
    },
    root: {
      width: "90%"
    }
  });
};

var iconFactoryByStatus = function iconFactoryByStatus(status) {
  switch (status) {
    case "Processing":
      return react_1.default.createElement("div", {
        className: "bb8-step processing"
      }, react_1.default.createElement("img", {
        src: require("../assets/images/bb8-processing-24px.svg"),
        alt: "Processing"
      }));

    case "OnHold":
      return react_1.default.createElement("div", {
        id: "step-hold",
        className: "bb8-step hold"
      }, react_1.default.createElement("img", {
        src: require("../assets/images/bb8-warning-24px.svg"),
        alt: "On Hold"
      }));

    case "Rejected":
      return react_1.default.createElement("div", {
        id: "step-rejected",
        className: "bb8-step rejected"
      }, react_1.default.createElement("img", {
        src: require("../assets/images/bb8-rejected-24px.svg"),
        alt: "Rejected"
      }));

    case "Complete":
      return react_1.default.createElement("div", {
        id: "step-completed",
        className: "bb8-step completed"
      }, react_1.default.createElement("img", {
        src: require("../assets/images/bb8-done-24px.svg"),
        alt: "Completed"
      }));

    default:
      return react_1.default.createElement("div", {
        className: "bb8-step idle"
      });
  }
};

var BB8Stepper = function BB8Stepper(_a) {
  var steps = _a.steps,
      activeStep = _a.activeStep,
      classes = _a.classes;
  return react_1.default.createElement("div", {
    id: "root-div",
    className: classes.root
  }, react_1.default.createElement(Stepper_1.default, {
    activeStep: activeStep,
    alternativeLabel: true
  }, steps.map(function (_a, index) {
    var title = _a.title,
        status = _a.status,
        lastUpdated = _a.lastUpdated;
    return react_1.default.createElement(Step_1.default, {
      id: "step-" + (index + 1),
      key: title
    }, react_1.default.createElement(StepLabel_1.default, {
      icon: iconFactoryByStatus(status)
    }, react_1.default.createElement("div", null, react_1.default.createElement("div", {
      id: "title",
      className: "bb8-stepper title"
    }, title), react_1.default.createElement("div", {
      id: "last-updated-date",
      className: "bb8-stepper"
    }, lastUpdated ? moment_1.default(lastUpdated).format("MM/DD/YYYY") : "-"), react_1.default.createElement("div", {
      id: "last-updated-from-now",
      className: "bb8-stepper last-update"
    }, lastUpdated ? "(" + moment_1.default(lastUpdated).fromNow() + ")" : ""))));
  })));
};

exports.default = styles_1.withStyles(styles)(BB8Stepper);